var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.new_mail_count > 0),expression:"new_mail_count > 0"}],staticStyle:{"display":"inline","position":"relative","top":"4px"}},[_c('el-badge',{staticClass:"item",attrs:{"value":_vm.new_mail_count + ' new'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }